import type { TableView } from 'api/models/TableView';
import { TableView as TableViewEnum } from 'api/models/TableView';
import type { TableViewListResponse } from 'api/models/TableViewListResponse';
import { ApiService } from 'api/services/ApiService';

const MODELS_VIEW_TYPE = TableViewEnum.view_type.MODELS;
const VALUATIONS_VIEW_TYPE = TableViewEnum.view_type.VALUATIONS;

export const listTableViews = (viewType: TableViewEnum.view_type): Promise<TableViewListResponse> =>
  ApiService.apiDashboardWorkboardTableViewsList(viewType);

export const createTableView = (
  data: TableView,
  viewType: TableViewEnum.view_type
): Promise<TableView> => ApiService.apiDashboardWorkboardTableViewsCreate(data, viewType);

export const updateTableView = (id: string, data: Partial<TableView>): Promise<TableView> =>
  ApiService.apiDashboardWorkboardTableViewsPartialUpdate(id, data as TableView);

export const deleteTableView = (id: string): Promise<void> =>
  ApiService.apiDashboardWorkboardTableViewsDelete(id);

export const listModelsTableViews = (): Promise<TableViewListResponse> =>
  listTableViews(MODELS_VIEW_TYPE);

export const createModelsTableView = (data: TableView): Promise<TableView> =>
  createTableView(data, MODELS_VIEW_TYPE);

export const updateModelsTableView = (id: string, data: Partial<TableView>): Promise<TableView> =>
  updateTableView(id, data);

export const deleteModelsTableView = (id: string): Promise<void> => deleteTableView(id);

export const listValuationsTableViews = (): Promise<TableViewListResponse> =>
  listTableViews(VALUATIONS_VIEW_TYPE);

export const createValuationsTableView = (data: TableView): Promise<TableView> =>
  createTableView(data, VALUATIONS_VIEW_TYPE);

export const updateValuationsTableView = (id: string, data: Partial<TableView>): Promise<TableView> =>
  updateTableView(id, data);

export const deleteValuationsTableView = (id: string): Promise<void> => deleteTableView(id);
